// extracted by mini-css-extract-plugin
export default {"placeholder":"_74df06f","shimmer":"_923d51a9","shimmerLoadingBackground":"_5bebb9c1"};